<!--  -->
<template>
  <div class="claim-alert">
    <el-dialog
      title="学者认领确认"
      align="center"
      @close="handleClose"
      :visible.sync="dialogVisible"
      width="640px"
    >
      <div class="paper">
        <h5 class="title">[J] 国外图书馆微博客建设及其启示</h5>
        <p>
          <span class="title">所属榜单：</span>管理学 > 图情档案管理 > 图书馆学 
        </p>
        <p>
          <span class="title">学者姓名：</span>李金波 
        </p>
        <p>
          <span class="title">学者单位：</span>图书馆／微博客／TWITTER／国外 
        </p>
        <p>
          <span class="title">主要领域：</span>社交网络 微博客 高校图书馆
        </p>
        <p>
          <span class="title">代表作：</span>国外图书馆微博客建设及其启示
        </p>
        <h5 class="title mt20">认领协议</h5>
        <p>
          1、协议内容 <br>2、协议内容 <br>3、协议内容 <br>4、协议内容
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      data: {}
    };
  },
  props: {
    detailValue: String
    // props: ['post'],
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open() {
      this.dialogVisible = true;
      //   this.$nextTick(() => {
      console.log(this.detailValue);
      //   });
    },
    handleClose() {
      console.log(this.dialogVisible);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.mb20 {
  margin-bottom: 20px;
}
.mt20 {
  margin-top: 20px;
}
.claim-alert .paper p{
  line-height: 24px;
  font-size: 14px;
}
.paper {
  text-align: left;
  padding: 0 20px;
}
.paper h5 {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.paper .rdfyk {
  color: #4267b2;
}
.paper .rdfyk::before {
  content: " ";
  background: url("../../assets/rdfyk.svg") no-repeat;
  background-size: 100%;
  margin-right: 5px;
  position: relative;
  top: 2px;
  display: inline-block;
  height: 14px;
  width: 16px;
}
</style>


// WEBPACK FOOTER //
// src/view/common/paperclaim.vue